import { render, staticRenderFns } from "./WriteCustomerList.vue?vue&type=template&id=0695dfc0&scoped=true&"
import script from "./WriteCustomerList.vue?vue&type=script&lang=js&"
export * from "./WriteCustomerList.vue?vue&type=script&lang=js&"
import style0 from "./WriteCustomerList.vue?vue&type=style&index=0&id=0695dfc0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0695dfc0",
  null
  
)

export default component.exports